/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Effect Map component for the Impact Evaluation Dashboard
Author: Deimos Space UK

Version: 1.0
*/
import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Alert } from "reactstrap";
import Spinner from 'react-bootstrap/Spinner';

import { getImage } from "../../../../api/api";
import { useParams } from "react-router-dom";



export default function EffectMap(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [idArray, setIdArray] = useState([]);
  const [effectMapOption, setEffectMapOption] = useState('collision_effect_map');
  const [effectMapImages, setEffectMapImages] = useState();

  const [constellation, setConstellation] = useState(false)
  const [spacecraftId, setSpacecraftId] = useState(null)
  const [spacecraftIdArray, setSpacecraftIdArray] = useState([])

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const { id } = useParams();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const optionsGEO = [
    {
      value: 'collision_effect_map',
      label: 'Collision effect map'
    }, {
      value: 'explosion_effect_map',
      label: 'Explosion effect map'
    },
  ]
  const options = [
    {
      value: 'collision_effect_map',
      label: 'Collision effect map'
    }, {
      value: 'explosion_effect_map',
      label: 'Explosion effect map'
    },
    {
      value: 'probability_of_collision',
      label: 'Probability of collision'
    },
    {
      value: 'debris_distribution_map',
      label: 'Debris distribution map'
    }
  ]

  useEffect(() => {
    setConstellation(props.constellation)
    setSpacecraftId(props.spacecraftId)
    setSpacecraftIdArray(props.spacecraftIdOrigin)
  }, [props.spacecraftId, props.spacecraftIdOrigin, props.constellation, props.region, options, optionsGEO])

  useEffect(() => {
    setLoading(true)
    setError(false)
    if (constellation && spacecraftId) {
      getImage(`/api/maps/${effectMapOption}?spacecraft_id=${spacecraftId}`)
        .then((data) => {
          if (data[1]) {
            setEffectMapImages(URL.createObjectURL(data[0]))
            setLoading(false)
            setError(false)
          } else {
            setLoading(false)
            setError(true)
          }
        })
        .catch((error) => {
          setLoading(false)
          setError(true)
        })
    } else if (spacecraftIdArray && spacecraftIdArray[0]) {
      getImage(`/api/maps/${effectMapOption}?spacecraft_id=${spacecraftIdArray[0]}`)
        .then((data) => {
          if (data[1]) {
            setEffectMapImages(URL.createObjectURL(data[0]))
            setLoading(false)
            setError(false)
          }
          else {
            setLoading(false)
            setError(true)
          }
        })
        .catch((error) => {
          setLoading(false)
          setError(true)
        })
    }
  }, [id, effectMapOption, idArray, constellation, spacecraftId, spacecraftIdArray]);





  return (
    <React.Suspense>
      <Card className="widget-flat h-100">
        <CardBody>
          <Row >
            <h4 style={{ color: '#003247' }} className="header-title float-left col " >MAPS</h4>
            <></>
            <Col>
              <Dropdown className="float-right" isOpen={dropdownOpen} toggle={toggle} >
                <DropdownToggle style={{ background: "#003247" }} caret>{props.region && props.region !== 'GEO' ? options.find(o => o.value === effectMapOption)?.label : optionsGEO.find(o => o.value === effectMapOption)?.label}</DropdownToggle>
                <DropdownMenu  >


                  {
                    props.region && props.region !== 'GEO' ? (
                      <>
                        <DropdownItem onClick={() => setEffectMapOption('collision_effect_map')}>Collision effect map</DropdownItem>
                        <DropdownItem onClick={() => setEffectMapOption('explosion_effect_map')}>Explosion effect map</DropdownItem>
                        <DropdownItem onClick={() => setEffectMapOption('probability_of_collision')}>Probability of collision</DropdownItem>
                        <DropdownItem onClick={() => setEffectMapOption('debris_distribution_map')}>Debris distribution map</DropdownItem>
                      </>
                    ) : (
                      <>
                        <DropdownItem onClick={() => setEffectMapOption('collision_effect_map')}>Collision effect map</DropdownItem>
                        <DropdownItem onClick={() => setEffectMapOption('explosion_effect_map')}>Explosion effect map</DropdownItem>
                      </>
                    )
                  }
                </DropdownMenu>
              </Dropdown>

            </Col>
          </Row>
          <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>

            {error ?
              (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
                  <Alert color="warning">
                    <h4 className="alert-heading">No data available</h4>
                    <p>
                      There is no data available for this mission.
                    </p>
                  </Alert>
                </div>
              )
              :
              (<Col xs={12} style={{ display: 'flex', justifyContent: 'center', }}>
                {
                  loading ?
                    (
                      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <Spinner animation="border" role="status"></Spinner>
                      </div>
                    )
                    :
                    (
                      <img
                        src={effectMapImages}
                        className="img-fluid"
                        style={{ maxWidth: '80%', }}
                        alt="EffectMap-img"
                      />
                    )
                }

              </Col>
              )}
          </Row>

        </CardBody>
      </Card>
    </React.Suspense>
  );
}